import { render, staticRenderFns } from "./Wjzp.vue?vue&type=template&id=4262dca3&scoped=true"
import script from "./Wjzp.vue?vue&type=script&lang=js"
export * from "./Wjzp.vue?vue&type=script&lang=js"
import style0 from "./Wjzp.vue?vue&type=style&index=0&id=4262dca3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4262dca3",
  null
  
)

export default component.exports